import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ef0ac804"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-card" }
const _hoisted_2 = {
  key: 0,
  id: "photoAndAddress",
  class: "section page-card__content"
}
const _hoisted_3 = {
  key: 0,
  class: "partners-icon"
}
const _hoisted_4 = {
  id: "mainInfo",
  class: "only-mobile section page-card__content"
}
const _hoisted_5 = { class: "page-card__main-info" }
const _hoisted_6 = { class: "items-in-line flex-start" }
const _hoisted_7 = { class: "l-font-size medium" }
const _hoisted_8 = { class: "third-color" }
const _hoisted_9 = { class: "items-in-line flex-start" }
const _hoisted_10 = {
  key: 0,
  class: "mt--10"
}
const _hoisted_11 = {
  key: 1,
  class: "mt--10"
}
const _hoisted_12 = {
  key: 0,
  class: "mt--10"
}
const _hoisted_13 = {
  id: "about",
  class: "section page-card__content"
}
const _hoisted_14 = { class: "mt--27" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "m-font-size mb--10" }, "Описание", -1))
const _hoisted_16 = { class: "page-card__content-description" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-size-title-block mb--20" }, "О ЖК", -1))
const _hoisted_18 = { class: "page-card-card-box" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-size-title-block mb--20" }, "О Застройщике", -1))
const _hoisted_20 = { class: "page-card-card-box" }
const _hoisted_21 = {
  key: 1,
  id: "map",
  class: "section page-card__map page-card__content"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-size-title-block mb--10" }, "На карте", -1))
const _hoisted_23 = { class: "mb--20" }
const _hoisted_24 = {
  id: "schedule",
  class: "section page-card__content"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-size-title-block mb--20" }, "График изменения цены", -1))
const _hoisted_26 = {
  id: "mortgage",
  class: "section page-card__content"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-size-title-block mb--20" }, "Ипотека", -1))
const _hoisted_28 = {
  key: 2,
  id: "seller",
  class: "mt--27 section page-card__content"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-size-title-block mb--10" }, "О Продавце", -1))
const _hoisted_30 = { class: "page-card-cards mt--27" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "medium" }, "Компания: ", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "medium" }, "Сайт: ", -1))
const _hoisted_33 = {
  key: 3,
  class: "page-card__content"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-size-title-block mb--20" }, "Ранее смотрели", -1))
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { class: "pb--10 pt--10 center" }
const _hoisted_37 = {
  key: 1,
  class: "page-card__grid-cards"
}
const _hoisted_38 = { class: "page-card__aside" }
const _hoisted_39 = { class: "l-font-size mb--5" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { key: 2 }
const _hoisted_42 = {
  key: 0,
  class: "mt--25"
}
const _hoisted_43 = { class: "mt--25" }
const _hoisted_44 = { class: "mt--25" }
const _hoisted_45 = { class: "image-modal__top-block" }
const _hoisted_46 = { class: "image-modal__top-block-title" }
const _hoisted_47 = { class: "items-in-line image-modal__top-block-btns none-Mobile" }
const _hoisted_48 = { class: "only-mobile" }
const _hoisted_49 = { class: "page-card__aside-mobile-card withChat" }
const _hoisted_50 = { class: "l-font-size medium none-Mobile" }
const _hoisted_51 = { class: "page-card__menu" }
const _hoisted_52 = ["href", "onClick"]

import { computed, inject, onMounted, Ref, ref } from 'vue';
import { FileType, ResultCardType } from '@/types';
import { useOfferCardsStore } from '@/store/modules/offerCards';
import { OfferSmallCard } from '@/components/Cards';

import {
  CallOrderCard,
  DeveloperSmallCard,
  MapBlock,
  ResidentialComplexSmallCard,
} from '@/components';
import {
  ActivityButtons,
  ImageModal,
  InfographicImgs,
  MenuBlock,
  MortgageBlock,
  PassportTable,
} from '../CardsComponents';
import { useRoute } from 'vue-router';
import { SmoothScrollOptions } from 'vue3-smooth-scroll';
import { useUserStore } from '@/store/modules/user';
import { useCompareStore } from '@/store/modules/compare';
import PhoneButton from '../../PhoneButton/PhoneButton.vue';
import { useChatStore } from '@/store/modules/chat';
import ActionsForImageModal from './ActionsForImageModal/ActionsForImageModal.vue';
import { useAppStore } from '@/store/modules/app';

type SeriesType = {
  name: string;
  data: { x: string; y: number }[];
}[];

type MenuItemType = {
  id: string;
  title: string;
  hide?: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'OfferCard',
  props: {
    offerCard: {},
    commission: {},
    partnerFiles: {}
  },
  emits: ['changeIsFavorite', 'showPartnersFiles'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const showImageModal = ref(false);
const showAllDescription = ref(false);
const showFurther = ref(false);
const costLoading = ref(false);
const viewedAds = computed((): ResultCardType[] => {
  return useOfferCardsStore().viewedAds.filter(el => el.id !== props.offerCard.id);
});
const showSellerBlock = computed(() => {
  return (
    props.offerCard.seller.logo_path_company ||
    props.offerCard.seller.title_company ||
    props.offerCard.seller.site_company
  );
});
const options = {
  chart: {
    width: '100%',
    height: '100%',
    dataLabels: {
      enabled: true,
    },
    markers: {
      size: 1,
    },
    toolbar: {
      show: false,
    },
    locales: [
      {
        name: 'ru',
        options: {
          months: [
            'Январь',
            'Февраль',
            'Март',
            'Апрель',
            'Мая',
            'Июнь',
            'Июль',
            'Август',
            'Сентябрь',
            'Октябрь',
            'Ноябрь',
            'Декабрь',
          ],
          shortMonths: [
            'Янв',
            'Феб',
            'Март',
            'Апр',
            'Май',
            'Июнь',
            'Июль',
            'Авг',
            'Сент',
            'Окт',
            'Ноя',
            'Дек',
          ],
        },
      },
    ],
    defaultLocale: 'ru',
    fontFamily: 'Roboto',
    foreColor: '#757575',
    animations: {
      enabled: true,
      easing: 'easeinout',
      speed: 800,
      animateGradually: {
        enabled: true,
        delay: 150,
      },
      dynamicAnimation: {
        enabled: true,
        speed: 350,
      },
    },

    zoom: {
      enabled: false,
    },
  },
  colors: ['#009D3E'],
  fontSize: '12px',
  stroke: {
    curve: 'straight',
    width: 2,
  },
  grid: {
    xaxis: {
      lines: {
        show: true,
      },
    },
    row: {
      colors: ['#F9F9F9'],
    },
    column: {
      colors: ['#F9F9F9'],
    },
  },
  xaxis: {
    type: 'datetime',
    labels: {
      format: 'MM.yyyy',
      style: {
        fontSize: '14px !important',
      },
    },
  },
  yaxis: {
    labels: {
      style: {
        fontSize: '10px',
      },
    },
  },
  fill: {
    type: 'gradient',
    gradient: {
      gradientToColors: ['#ABBA00'],
      opacityFrom: 0.7,
      opacityTo: 0.5,
    },
  },
  tooltip: {
    enabled: true,
    x: {
      show: false,
    },
  },
  markers: {
    size: 1,
  },
};
const series: Ref<SeriesType> = ref([]);

const menuItems = computed((): MenuItemType[] => {
  return [
    {
      id: 'photoAndAddress',
      title: 'Фото и адрес',
    },
    {
      id: 'about',
      title: 'О доме / Описание',
    },
    {
      id: 'developerAndLCD',
      title: 'О Застройщике / ЖК',
      hide: !props.offerCard.aboutResidentialComplex && !props.offerCard.aboutDeveloper,
    },
    {
      id: 'map',
      title: 'На карте',
    },
    {
      id: 'schedule',
      title: 'График изменения цены',
    },
    {
      id: 'mortgage',
      title: 'Ипотека',
    },
    {
      id: 'seller',
      title: 'О продавце',
      hide: !showSellerBlock.value,
    },
  ];
});

const description = computed((): string => {
  let sliced: string;

  sliced = props.offerCard.description?.slice(0, 400);

  if (sliced?.length < props.offerCard.description?.length) {
    showFurther.value = true;
  }

  return showAllDescription.value ? props.offerCard.description : sliced;
});
const pricePerMeter = (card: ResultCardType): number | undefined => {
  if (card.id === card.landId && card.landArea) {
    return Math.round(+card.price / +card.landArea);
  }
  if (card.houseArea) {
    return Math.round(+card.price / +card.houseArea);
  }

  return undefined;
};

const passportTableData = computed(() => {
  let tableData = [];

  if (props.offerCard.passportHouse && props.offerCard.passportHouse.length) {
    tableData.push({
      title: 'Дом',
      items: props.offerCard.passportHouse,
    });
  }
  if (props.offerCard.passportLand && props.offerCard.passportLand.length) {
    tableData.push({
      title: 'Земля',
      items: props.offerCard.passportLand,
    });
  }

  return tableData;
});

const smoothScroll = inject('smoothScroll') as (args: SmoothScrollOptions) => void;

onMounted(async () => {
  const hash = useRoute().hash;

  if (hash) {
    const myEl = document.getElementById(hash.replace('#', ''));

    if (myEl) {
      smoothScroll({
        scrollTo: myEl,
        container: myEl,
      });
    }
  }

  costLoading.value = true;
  const res = await useOfferCardsStore().getHouseCostHistory(props.offerCard.id);

  if (res) {
    series.value.push({
      name: 'цена',
      data: res.map(el => {
        return {
          x: el.date,
          y: +el.cost,
        };
      }),
    });
    if (!series.value[0].data.length && props.offerCard.price) {
      series.value[0].data.push({
        x: new Date().toISOString().slice(0, 10),
        y: +props.offerCard.price,
      });
    }
  }
  costLoading.value = false;
});

return (_ctx: any,_cache: any) => {
  const _component_base_image = _resolveComponent("base-image")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_image_gallery = _resolveComponent("base-image-gallery")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_card = _resolveComponent("base-card")!
  const _component_base_skeleton_loader = _resolveComponent("base-skeleton-loader")!
  const _component_apexchart = _resolveComponent("apexchart")!
  const _component_base_swiper = _resolveComponent("base-swiper")!
  const _component_base_divider = _resolveComponent("base-divider")!
  const _component_base_menu = _resolveComponent("base-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (
          _ctx.offerCard.img
            ? _ctx.offerCard.img.length || _ctx.offerCard.landImgs.length
            : _ctx.offerCard.landImgs.length
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_base_image_gallery, {
              "img-name": _ctx.offerCard.address,
              "img-title": _ctx.offerCard.address,
              navigation: true,
              "slides-group": [
            {
              id: 1,
              title: 'Фотографии дома',
              slides: _ctx.offerCard.img
                ? [..._ctx.offerCard.img, ..._ctx.offerCard.landImgs]
                : _ctx.offerCard.landImgs,
            },
          ],
              "space-between": 5
            }, {
              item: _withCtx((itemProps) => [
                _createElementVNode("button", {
                  class: "page-card__item-img-box",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (showImageModal.value = true))
                }, [
                  (_ctx.offerCard.affiliateProgramId)
                    ? (_openBlock(), _createElementBlock("button", _hoisted_3, "₽"))
                    : _createCommentVNode("", true),
                  _createVNode(_component_base_image, {
                    name: _ctx.offerCard.address,
                    src: itemProps.data.item,
                    title: _ctx.offerCard.address,
                    "border-radius": "",
                    class: "page-card__item-img",
                    contain: "",
                    height: "100%",
                    width: "100%"
                  }, null, 8, ["name", "src", "title"]),
                  (!_ctx.offerCard.isPhysics)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 1,
                        to: { name: 'checkResult', query: { id: _ctx.offerCard.landId } },
                        class: "verifiedBtn verifiedBtn-text center"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Проверено ")
                        ]),
                        _: 1
                      }, 8, ["to"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["img-name", "img-title", "slides-group"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.offerCard.price ? _ctx.offerCard.price.toLocaleString() : '-') + " ₽ ", 1),
            _createElementVNode("div", _hoisted_8, _toDisplayString(`${pricePerMeter(_ctx.offerCard) ? pricePerMeter(_ctx.offerCard).toLocaleString() : '-'} ₽ за м²`), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            (_ctx.offerCard.rates && _ctx.offerCard.rates[0]?.minPayment)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Ипотека от: " + _toDisplayString(_ctx.offerCard.rates[0].minPayment.toLocaleString()) + " ₽ ", 1))
              : _createCommentVNode("", true),
            (_ctx.offerCard.affiliateProgramId && _ctx.commission)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, " Комиссия: " + _toDisplayString(((_ctx.offerCard.price * _ctx.commission) / 100).toLocaleString()) + " ₽ ", 1))
              : _createCommentVNode("", true)
          ]),
          (_ctx.offerCard.affiliateProgramId && _ctx.partnerFiles.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(_component_base_button, {
                  "all-block-width": "",
                  height: "36",
                  "style-type": "greenBorder",
                  text: "Материалы продаж",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('showPartnersFiles', _ctx.offerCard.id)))
                })
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_unref(InfographicImgs), {
          infographics: _ctx.offerCard.infographics
        }, null, 8, ["infographics"]),
        _createVNode(_unref(PassportTable), {
          tableData: passportTableData.value,
          class: "mt--27"
        }, null, 8, ["tableData"]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _createTextVNode(_toDisplayString(description.value || '-') + " ", 1),
            (showFurther.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "main-color underline",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (showAllDescription.value = !showAllDescription.value))
                }, _toDisplayString(showAllDescription.value ? 'Скрыть' : 'Далее'), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", {
        id: "developerAndLCD",
        class: _normalizeClass([{ 'page-card__content': _unref(useAppStore)().getWindowWidth() > 600 }, "section page-card-cards"])
      }, [
        (_ctx.offerCard.aboutResidentialComplex)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass({ 'page-card__content': _unref(useAppStore)().getWindowWidth() <= 600 })
            }, [
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_unref(ResidentialComplexSmallCard), {
                  "offer-card": _ctx.offerCard,
                  "residential-complex": _ctx.offerCard.aboutResidentialComplex
                }, null, 8, ["offer-card", "residential-complex"])
              ])
            ], 2))
          : _createCommentVNode("", true),
        (_ctx.offerCard.aboutDeveloper)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass({ 'page-card__content': _unref(useAppStore)().getWindowWidth() <= 600 })
            }, [
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_unref(DeveloperSmallCard), {
                  developer: _ctx.offerCard.aboutDeveloper
                }, null, 8, ["developer"])
              ])
            ], 2))
          : _createCommentVNode("", true)
      ], 2),
      (_ctx.offerCard.coordinates)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.offerCard.address), 1),
            _createVNode(_component_base_card, {
              "full-width-mobile": "",
              "without-mobile-shadow": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(MapBlock), {
                  "center-point-map": _ctx.offerCard.coordinates,
                  "result-cards-coordinates": [
              { id: _ctx.offerCard.id, coordinates: _ctx.offerCard.coordinates },
            ],
                  class: "mt--20",
                  height: "370"
                }, null, 8, ["center-point-map", "result-cards-coordinates"])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_24, [
        _hoisted_25,
        (costLoading.value)
          ? (_openBlock(), _createBlock(_component_base_skeleton_loader, {
              key: 0,
              style: { height: '260px' },
              type: "img"
            }))
          : (_openBlock(), _createBlock(_component_base_card, {
              key: 1,
              "without-mobile-shadow": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_apexchart, {
                  options: options,
                  series: series.value,
                  height: "260",
                  type: "area"
                }, null, 8, ["series"])
              ]),
              _: 1
            }))
      ]),
      _createElementVNode("div", _hoisted_26, [
        _hoisted_27,
        _createVNode(_unref(MortgageBlock), {
          mortgage: _ctx.offerCard.rates
        }, null, 8, ["mortgage"])
      ]),
      (showSellerBlock.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
            _hoisted_29,
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", null, [
                _createVNode(_component_base_card, {
                  class: "page-card__seller-info",
                  "full-width-mobile": "",
                  "without-mobile-shadow": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_base_image, {
                      src: _ctx.offerCard.seller.logo_path_company,
                      class: "small-card__img",
                      contain: "",
                      height: "65",
                      name: "seller",
                      width: "100%"
                    }, null, 8, ["src"]),
                    _createElementVNode("div", null, [
                      _hoisted_31,
                      _createElementVNode("span", null, _toDisplayString(_ctx.offerCard.seller.title_company || '-'), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_32,
                      _createElementVNode("span", null, _toDisplayString(_ctx.offerCard.seller.site_company || '-'), 1)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", null, [
                _createVNode(_unref(CallOrderCard), {
                  cardId: _ctx.offerCard.id
                }, null, 8, ["cardId"])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (viewedAds.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
            _hoisted_34,
            _createElementVNode("div", null, [
              (_unref(useAppStore)().getWindowWidth() > 600)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    _createVNode(_component_base_swiper, {
                      slides: [...viewedAds.value],
                      "space-between": 20,
                      "width-item": 240,
                      class: "mt--20 mb--20"
                    }, {
                      item: _withCtx((itemProps) => [
                        _createElementVNode("div", _hoisted_36, [
                          _createVNode(_unref(OfferSmallCard), {
                            card: itemProps.data,
                            "without-scale": "",
                            onChangeActive: ($event: any) => (
                      _ctx.$router.push({
                        name: 'offerCard',
                        params: { url: itemProps.data.landUrl },
                      })
                    )
                          }, null, 8, ["card", "onChangeActive"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["slides"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_37, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(viewedAds.value, (card) => {
                      return (_openBlock(), _createBlock(_unref(OfferSmallCard), {
                        key: card.id,
                        card: card,
                        "without-scale": "",
                        onChangeActive: _cache[3] || (_cache[3] = ($event: any) => (
                _ctx.$router.push({
                  name: 'offerCard',
                  params: { url: _ctx.itemProps.data.landUrl },
                })
              ))
                      }, null, 8, ["card"]))
                    }), 128))
                  ]))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_38, [
      _createElementVNode("div", null, [
        _createVNode(_component_base_card, { class: "page-card__main-info" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.offerCard.price ? _ctx.offerCard.price.toLocaleString() : '-') + " ₽ ", 1),
            _createElementVNode("div", null, _toDisplayString(`За м²: ${pricePerMeter(_ctx.offerCard) ? pricePerMeter(_ctx.offerCard).toLocaleString() : '-'} ₽`), 1),
            (_ctx.offerCard.rates && _ctx.offerCard.rates[0]?.minPayment)
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, " Ипотека от: " + _toDisplayString(_ctx.offerCard.rates[0].minPayment.toLocaleString()) + " ₽ ", 1))
              : _createCommentVNode("", true),
            (_ctx.offerCard.affiliateProgramId)
              ? (_openBlock(), _createBlock(_component_base_divider, {
                  key: 1,
                  class: "page-card__main-info-divider"
                }))
              : _createCommentVNode("", true),
            (_ctx.offerCard.affiliateProgramId && _ctx.commission)
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, " Комиссия B2B: " + _toDisplayString(((_ctx.offerCard.price * _ctx.commission) / 100).toLocaleString()) + " ₽ ", 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      (_ctx.offerCard.affiliateProgramId && _ctx.partnerFiles.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
            _createVNode(_component_base_button, {
              "all-block-width": "",
              height: "36",
              "style-type": "coloredBorder",
              text: "Материалы продаж",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('showPartnersFiles', _ctx.offerCard.id)))
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_43, [
        _createVNode(_component_base_card, null, {
          default: _withCtx(() => [
            _createVNode(_unref(MenuBlock), {
              "menu-items": menuItems.value.filter(el => !el.hide)
            }, null, 8, ["menu-items"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_44, [
        _createVNode(_component_base_card, null, {
          default: _withCtx(() => [
            _createVNode(_unref(ActivityButtons), {
              docs: _ctx.offerCard.docs,
              isCompare: _unref(useCompareStore)().getIsCompare(_ctx.offerCard.id),
              isFavorite: _unref(useUserStore)().getIsFavorite(_ctx.offerCard.landId),
              "offer-card": _ctx.offerCard,
              phone: _ctx.offerCard.phone,
              onChangeIsFavorite: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('changeIsFavorite', _ctx.offerCard.landId)))
            }, null, 8, ["docs", "isCompare", "isFavorite", "offer-card", "phone"])
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_unref(ImageModal), {
      modelValue: showImageModal.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((showImageModal).value = $event)),
      images: _ctx.offerCard.img || _ctx.offerCard.landImgs
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("h3", _hoisted_46, _toDisplayString(_ctx.offerCard.name), 1),
          _createElementVNode("div", _hoisted_47, [
            _createVNode(ActionsForImageModal, {
              "offer-card": _ctx.offerCard,
              phone: _ctx.offerCard.phone,
              onChangeIsFavorite: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('changeIsFavorite', _ctx.offerCard.landId))),
              onClose: _cache[7] || (_cache[7] = ($event: any) => (showImageModal.value = !showImageModal.value))
            }, null, 8, ["offer-card", "phone"])
          ])
        ])
      ]),
      "bottom-box": _withCtx(() => [
        _createElementVNode("div", _hoisted_48, [
          _createVNode(ActionsForImageModal, {
            "offer-card": _ctx.offerCard,
            phone: _ctx.offerCard.phone,
            onChangeIsFavorite: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('changeIsFavorite', _ctx.offerCard.landId))),
            onClose: _cache[9] || (_cache[9] = ($event: any) => (showImageModal.value = !showImageModal.value))
          }, null, 8, ["offer-card", "phone"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "images"]),
    (!showImageModal.value && !_unref(useChatStore)().miniMessenger.show)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 0,
          class: "page-card__aside-mobile",
          to: "#mobileDownMenu"
        }, [
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.offerCard.price?.toLocaleString()) + " ₽ ", 1),
            _createVNode(_component_base_button, {
              "all-block-width": "",
              height: "36",
              "style-type": "coloredBorder",
              text: "Написать",
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_unref(useChatStore)().openMiniMessenger(_ctx.offerCard)))
            }),
            _createVNode(PhoneButton, {
              phone: _ctx.offerCard.phone,
              height: "36"
            }, null, 8, ["phone"]),
            _createVNode(_component_base_menu, null, {
              menuItems: _withCtx((menuItemsProps) => [
                _createElementVNode("div", _hoisted_51, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItems.value.filter(el => !el.hide), (item, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.id
                    }, [
                      _createElementVNode("a", {
                        href: `#${item.id}`,
                        class: "page-card__menu-item",
                        onClick: ($event: any) => (menuItemsProps.events.handleClick())
                      }, _toDisplayString(item.title), 9, _hoisted_52),
                      (i !== menuItems.value.filter(el => !el.hide).length - 1)
                        ? (_openBlock(), _createBlock(_component_base_divider, { key: 0 }))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128)),
                  _createVNode(_unref(ActivityButtons), {
                    docs: _ctx.offerCard.docs,
                    isCompare: _unref(useCompareStore)().getIsCompare(_ctx.offerCard.id),
                    isFavorite: _unref(useUserStore)().getIsFavorite(_ctx.offerCard.landId),
                    "offer-card": _ctx.offerCard,
                    phone: _ctx.offerCard.phone,
                    withFeedBack: false,
                    class: "page-card__menu-activities",
                    onChangeIsFavorite: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('changeIsFavorite', _ctx.offerCard.landId)))
                  }, null, 8, ["docs", "isCompare", "isFavorite", "offer-card", "phone"])
                ])
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})